var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-loader"},[_c('div',{staticClass:"loader__logo"},[_c('img',{attrs:{"src":require("../assets/playmetrix-logo.png")}}),_c('SelfBuildingSquareSpinner',{attrs:{"size":50,"color":"#E8D26F"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }